import { render, staticRenderFns } from "./Allocation.vue?vue&type=template&id=01c22c81&scoped=true&lang=pug&"
import script from "./Allocation.vue?vue&type=script&lang=ts&"
export * from "./Allocation.vue?vue&type=script&lang=ts&"
import style0 from "./Allocation.vue?vue&type=style&index=0&id=01c22c81&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c22c81",
  null
  
)

export default component.exports